module.exports = __webpack_public_path__ + "static/img/manual_ja_13.7822995.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_13.png
// module id = vqQN
// module chunks = 4